import { IUpdateProfilePayload } from '@boxx/profile-core/lib/repositories/IProfile.repository';
import { createAction, props } from '@ngrx/store';
import { IUpdateProfileStorePayload, StoreProfileModel, StoreProfileModelProps } from '../../models/Store.model';

export enum StoreProfileActionTypes {
  loadProfileBegin = '[STORE] Load Profile Begin',
  loadProfileSuccess = '[STORE] Load Profile Success',
  loadProfileFail = '[STORE] Load Profile Fail',

  updateProfileBegin = '[STORE] Update Profile Begin',
  updateProfileSuccess = '[STORE] Update Profile Success',
  updateProfileFail = '[STORE] Update Profile Fail',

  imageProfileUploadedBegin = '[STORE] Load Image Profile Uploaded Begin',
  imageProfileUploadedSuccess = '[STORE] Load Image Profile Uploaded Success',
  imageProfileUploadedFail = '[STORE] Load Image Profile Uploaded Fail',

  deleteImageProfileBegin = '[STORE] Delete Image Profile Begin',
  deleteImageProfileSuccess = '[STORE] Delete Image Profile Success',
  deleteImageProfileFail = '[STORE] Delete Image Profile Fail',

  clearProfileSuccessErrorData = '[STORE] Clear Profile Success/Error Data',
}

export const loadProfileBeginAction = createAction(
  StoreProfileActionTypes.loadProfileBegin
);

export const loadProfileSuccessAction = createAction(
  StoreProfileActionTypes.loadProfileSuccess,
  props<{ payload: StoreProfileModel }>()
);

export const loadProfileFailAction = createAction(
  StoreProfileActionTypes.loadProfileFail,
  props<{ errors: any }>()
);

export const updateProfileBeginAction = createAction(
  StoreProfileActionTypes.updateProfileBegin,
  props<{ payload: IUpdateProfileStorePayload }>()
);

export const updateProfileSuccessAction = createAction(
  StoreProfileActionTypes.updateProfileSuccess,
  props<{ payload: any }>()
);

export const updateProfileFailAction = createAction(
  StoreProfileActionTypes.updateProfileFail,
  props<{ errors: any }>()
);

export const uploadImageProfileBeginAction = createAction(
  StoreProfileActionTypes.imageProfileUploadedBegin,
  props<{ payload: string }>()
);

export const uploadImageProfileSuccessAction = createAction(
  StoreProfileActionTypes.imageProfileUploadedSuccess,
  props<{ payload: any }>()
);

export const uploadImageProfileFailAction = createAction(
  StoreProfileActionTypes.imageProfileUploadedFail,
  props<{ errors: any }>()
);

export const clearProfileSuccessErrorDataAction = createAction(
  StoreProfileActionTypes.clearProfileSuccessErrorData
);

export const deleteImageProfileBeginAction = createAction(
  StoreProfileActionTypes.deleteImageProfileBegin,
  props<{ id: number }>()
);

export const deleteImageProfileSuccessAction = createAction(
  StoreProfileActionTypes.deleteImageProfileSuccess,
  props<{ payload: any }>()
);

export const deleteImageProfileFailAction = createAction(
  StoreProfileActionTypes.deleteImageProfileFail,
  props<{ errors: any }>()
);